<ng-content *ngIf="!hideHeader" select="[header]"></ng-content>
<i *ngIf="!disableClose" class="close material-icons" (click)="dialogClose()">close</i>
<h1 class="text-center text-muted mt-4 modal-title" [innerHtml]="title | translate"></h1>
<div [ngClass]="bodyClass">
    <mat-dialog-content>
        <ng-content select="[content]"></ng-content>
    </mat-dialog-content>

    <mat-dialog-actions class="mt-4" [ngStyle]="justifyContent" *ngIf="!hideActions">
        <ng-content select="[actions]"></ng-content>
    </mat-dialog-actions>
</div>
